import React from 'react';

const SalesFilterBar = ({
  filters,
  setFilters,
  handleFilter,
  handleReset,
  setPresetRange,
  styles,
}) => {
  return (
    <div
      className="card mb-4"
      style={{ ...styles.softCard, ...styles.stickyFilter }}
    >
      <div className="card-body py-3">
        <div className="row align-items-end">
          <div className="col-md-3 mb-2 mb-md-0">
            <label className="small text-muted mb-1">Start Date (first used)</label>
            <input
              type="date"
              className="form-control"
              value={filters.start_date}
              onChange={(e) =>
                setFilters((f) => ({ ...f, start_date: e.target.value }))
              }
            />
          </div>

          <div className="col-md-3 mb-2 mb-md-0">
            <label className="small text-muted mb-1">End Date</label>
            <input
              type="date"
              className="form-control"
              value={filters.end_date}
              onChange={(e) =>
                setFilters((f) => ({ ...f, end_date: e.target.value }))
              }
            />
          </div>

          <div className="col-md-6">
            <div className="d-flex flex-wrap align-items-center justify-content-md-end gap-2">
              <div className="btn-group mr-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setPresetRange(1)}
                >
                  Today
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setPresetRange(7)}
                >
                  7D
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setPresetRange(30)}
                >
                  30D
                </button>
              </div>

              <button className="btn btn-primary" onClick={handleFilter}>
                <i className="fas fa-filter mr-1" /> Apply Filters
              </button>
              <button className="btn btn-outline-secondary" onClick={handleReset}>
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesFilterBar;
